let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dPeMl")).then(() => parcelRequire('lvf7Q'));